import request from "@/api/request";

export function getProductHistoricalPrice(data) {
    return request({
        url: '/api/product/getProductHistoricalPrice',
        method: 'post',
        data: data
    })
}
